export class COLUMNS {
    static sender = 'sender';
    static subject = 'subject';
    static startDate = 'startDate';
    static endDate = 'endDate';
}